!(function () {
  'use strict';

  window.theme.variables = { productPageSticky: false };

  customElements.get('product-sticky') ||
    customElements.define(
      'product-sticky',
      class extends HTMLElement {
        constructor() {
          super();

          this.stickyScrollTop = 0;
          this.scrollLastPosition = 0;
          this.stickyDefaultTop = 0;
          this.currentPoint = 0;
          this.defaultTopBottomSpacings = 30;
          this.scrollTopPosition = window.scrollY;
          this.scrollDirectionDown = true;
          this.requestAnimationSticky = null;
          this.stickyFormLoad = true;
          this.stickyFormLastHeight = null;
          this.onChangeCounter = 0;
          this.scrollEvent = (event) => this.scrollEvents(event);
          this.resizeEvent = (event) => this.resizeEvents(event);
        }

        connectedCallback() {
          this.stickyScrollCheck();
          document.addEventListener('theme:resize', this.resizeEvent);
          this.initSticky();
        }

        initSticky() {
          if (!theme.variables.productPageSticky) return;

          this.requestAnimationSticky = requestAnimationFrame(() =>
            this.calculateStickyPosition()
          );

          this.addEventListener('theme:form:sticky', (event) => {
            this.removeAnimationFrame();
            this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(event)
            );
          });

          document.addEventListener('theme:scroll', this.scrollEvent);
        }

        scrollEvents(event) {
          if (event.detail !== null) {
            this.scrollTopPosition = event.detail.position;
            this.scrollDirectionDown = event.detail.down;
          }

          if (!this.requestAnimationSticky) {
            this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition()
            );
          }
        }

        resizeEvents() {
          this.stickyScrollCheck();
          document.removeEventListener('theme:scroll', this.scrollEvent);
          this.initSticky();
        }

        stickyScrollCheck() {
          const windowWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;

          if (windowWidth >= window.theme.sizes.large) {
            const productInfo = this.closest('product-info');
            const mediaSlider = productInfo?.querySelector(
              '[data-product-single-media-slider]'
            );

            if (!mediaSlider) return;

            if (this.offsetHeight < mediaSlider.offsetHeight) {
              theme.variables.productPageSticky = true;
              this.classList.add('is-sticky');
            } else {
              theme.variables.productPageSticky = false;
              this.classList.remove('is-sticky');
            }
          } else {
            theme.variables.productPageSticky = false;
            this.classList.remove('is-sticky');
          }
        }

        calculateStickyPosition(event = null) {
          const hasEventDetail = Boolean(event && event.detail);
          const isAccordionEvent = Boolean(
            hasEventDetail &&
              event.detail.element &&
              event.detail.element === 'accordion'
          );
          const stickyFormHeight = this.offsetHeight;
          const stickyBottomPosition =
            window.innerHeight -
            stickyFormHeight -
            this.defaultTopBottomSpacings;
          const scrollDistance = Math.abs(
            this.scrollTopPosition - this.scrollLastPosition
          );

          if (this.scrollDirectionDown) {
            this.stickyScrollTop -= scrollDistance;
          } else {
            this.stickyScrollTop += scrollDistance;
          }

          if (this.stickyFormLoad) {
            if (
              document.querySelector('[data-header-sticky]') &&
              document.querySelector('[data-header-height]')
            ) {
              this.stickyDefaultTop = parseInt(
                document
                  .querySelector('[data-header-height]')
                  .getBoundingClientRect().height
              );
            } else {
              this.stickyDefaultTop = this.defaultTopBottomSpacings;
            }

            this.stickyScrollTop = this.stickyDefaultTop;
          }

          this.stickyScrollTop = Math.min(
            Math.max(this.stickyScrollTop, stickyBottomPosition),
            this.stickyDefaultTop
          );

          const positionDifference = this.stickyScrollTop - this.currentPoint;

          this.currentPoint = this.stickyFormLoad
            ? this.stickyScrollTop
            : this.currentPoint + 0.5 * positionDifference;

          this.style.setProperty('--sticky-top', `${this.currentPoint}px`);
          this.scrollLastPosition = this.scrollTopPosition;
          this.stickyFormLoad = false;

          const shouldContinueAnimation =
            (isAccordionEvent && this.onChangeCounter <= 10) ||
            (isAccordionEvent &&
              this.stickyFormLastHeight !== stickyFormHeight) ||
            (this.stickyScrollTop !== this.currentPoint &&
              this.requestAnimationSticky);

          if (shouldContinueAnimation) {
            if (isAccordionEvent) {
              this.onChangeCounter += 1;
            }

            if (
              isAccordionEvent &&
              this.stickyFormLastHeight !== stickyFormHeight
            ) {
              this.onChangeCounter = 11;
            }

            this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(event)
            );
          } else if (this.requestAnimationSticky) {
            this.removeAnimationFrame();
          }

          this.stickyFormLastHeight = stickyFormHeight;
        }

        removeAnimationFrame() {
          if (!this.requestAnimationSticky) return;

          cancelAnimationFrame(this.requestAnimationSticky);
          this.requestAnimationSticky = null;
          this.onChangeCounter = 0;
        }

        disconnectedCallback() {
          document.removeEventListener('theme:resize', this.resizeEvent);

          if (theme.variables.productPageSticky) {
            document.removeEventListener('theme:scroll', this.scrollEvent);
          }
        }
      }
    );
})();
